// extracted by mini-css-extract-plugin
export var cardInnerStyle = "sr_key_takeaways-module--cardInnerStyle--J7vK7";
export var headingStyle = "sr_key_takeaways-module--headingStyle--QW-qf";
export var wrapperStyle = "sr_key_takeaways-module--wrapperStyle--1KOex";